import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=7ab634d1&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=7ab634d1&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab634d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ab634d1')) {
      api.createRecord('7ab634d1', component.options)
    } else {
      api.reload('7ab634d1', component.options)
    }
    module.hot.accept("./orderDetail.vue?vue&type=template&id=7ab634d1&scoped=true", function () {
      api.rerender('7ab634d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/buildPackage/packagePrint/components/orderDetail.vue"
export default component.exports